import script from "./CounterProposeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CounterProposeModal.vue?vue&type=script&setup=true&lang=js"

import "./CounterProposeModal.vue?vue&type=style&index=0&id=466fb52c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-466fb52c"]])

export default __exports__